import { Box, Typography } from '@mui/material';
import { DAYS_PER_MONTH } from '../entity';

type BonusDaysInfoProps = {
  remainingDays: number;
  creditInCzk: number;
  bonusDays: number;
  totalDays: number;
  currency?: 'CZK' | 'EUR';
};

const BonusDaysInfo = ({
  remainingDays,
  creditInCzk,
  bonusDays,
  totalDays,
  currency = 'CZK',
}: BonusDaysInfoProps) => (
  <Box
    sx={{
      bgcolor: 'success.50',
      p: 2,
      borderRadius: 1,
      border: '1px solid',
      borderColor: 'success.main',
    }}
  >
    <Typography variant="subtitle2" color="success.main" gutterBottom fontWeight="bold">
      🎁 Bonus dny za zbývající předplatné
    </Typography>
    <Typography variant="body2" color="text.primary">
      Zbývá vám <strong>{remainingDays} dní</strong> ({creditInCzk.toFixed(2)}{' '}
      {currency === 'EUR' ? '€' : 'Kč'} kredit). Získáte <strong>{bonusDays} bonus dní</strong> k
      novému předplatnému.
    </Typography>
    <Typography variant="body2" color="text.primary" sx={{ mt: 1 }}>
      <strong>Celková délka:</strong> {totalDays} dní ({DAYS_PER_MONTH} standardních + {bonusDays}{' '}
      bonus)
    </Typography>
  </Box>
);
export default BonusDaysInfo;
